<template>
    <ModalComponent :is-open="isModalOpen" :show-footer-buttons="true" :title="title" size="md" position="center" @update:isOpen="handleClose">
        <div class="p-4">
            <slot> Are you sure? </slot>
        </div>
        <template #footer>
            <div class="flex justify-end space-x-2">
                <button class="bg-green-400 hover:bg-green-500 text-white rounded-md py-2 px-4" @click="onConfirm(true)">Yes</button>
                <button class="bg-neutral-300 hover:bg-neutral-400 text-gray-800 rounded-md py-2 px-4" @click="onConfirm(false)">No</button>
            </div>
        </template>
    </ModalComponent>
</template>

<script setup>
import { ref, watch } from 'vue';
import ModalComponent from '@/components/global/modals/Modal.vue';

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false
    },
    title: {
        type: String,
        default: 'Confirm'
    }
});

const emit = defineEmits(['update:isOpen', 'confirm']);

const isModalOpen = ref(props.isOpen);

watch(
    () => props.isOpen,
    (newVal) => {
        isModalOpen.value = newVal;
    }
);

// If the modal is closed via the X button (or outside), treat it as a cancellation.
const handleClose = (value) => {
    if (!value) {
        emit('update:isOpen', false);
        emit('confirm', null); // null indicates cancellation
    }
};

const onConfirm = (choice) => {
    emit('confirm', choice);
    emit('update:isOpen', false);
};
</script>

<style scoped>
/* Component-specific styles (if required) */
</style>
